import {Pipe, PipeTransform} from '@angular/core';
import {DeliveryNoteImageDto} from '../../../Models/Purchases/Delivery-notes/delivery-note.interface';

@Pipe({
  name: 'deliveryNotePictures',
  standalone: false
})
export class DeliveryNotePicturesPipe implements PipeTransform {

  transform(items: DeliveryNoteImageDto[], filter: { isOcr: boolean }): DeliveryNoteImageDto[] {

    if (!items?.length) {
      return [];
    }

    return items.filter((item) => item.is_ocr === filter.isOcr);

  }

}